export default function direktLoginErrorController() {
	var $ctrl = this;
	$ctrl.goToDirektLogin = function () {
		if (angular.isDefined($ctrl.goToDirektLoginFunction)) {
			$ctrl.goToDirektLoginFunction();
		}
	};
	$ctrl.cancelAddBankAccount = function () {
		if (angular.isDefined($ctrl.cancelAddBankAccountFunction)) {
			$ctrl.cancelAddBankAccountFunction();
		}
	};
}
